import * as Icon from "@ant-design/icons";
import { Modal, Flex, Form, Row, Col, Switch } from "antd";
import { ColumnsType } from "antd/es/table";
import { useEffect } from "react";
import { GrupoContaBancoModel } from "../../models/grupoContaBanco/grupoContaBancoModel";
import { useAppSelector, useAppDispatch } from "../../util/hooks";
import CadastroGrupoContaBancoModal from "./modals/cadastrar";
import { setEntityGrupoContaBanco, setModalCadastrarGrupoContaBanco, setModalDeletarGrupoContaBanco } from "../../redux/slices/grupoContaBanco/grupoContaBancoSlice";
import { setTitle } from "../../redux/slices/configuracoes/configuracoesSlice";
import { buscarGrupoContaBanco, deletarGrupoContaBanco } from "../../services/grupoContaBancoService";
import TableComponent from "../../components/table/tableComponent";
import AcoesComponent from "../../components/table/acoesComponent";
import { ItemMenuAcoes } from "../../models/sistema/itemMenuAcoes";
import MensagemModal from "../../components/modal/mensagem";
import { ButtonComponent } from "../../components/button/cadastrar";

const GrupoContaBanco = () => {
  //estados globais
  const grupoContaBancoState = useAppSelector((state) => state.grupoContaBanco);

  //hooks
  const dispatch = useAppDispatch();

  //estados locais

  const editar = Object.values(grupoContaBancoState.entity).length !== 0;

  useEffect(() => {
    dispatch(setTitle("GRUPO DE CONTA BANCÁRIA"));
    dispatch(buscarGrupoContaBanco());
  }, []);

  const goCadastro = () => {
    dispatch(setEntityGrupoContaBanco({}));
    dispatch(setModalCadastrarGrupoContaBanco(true));
  };

  const closeModalCadastro = () => {
    dispatch(setModalCadastrarGrupoContaBanco(false));
  };

  const goEditar = (value: GrupoContaBancoModel) => {
    dispatch(setEntityGrupoContaBanco(value));
    dispatch(setModalCadastrarGrupoContaBanco(true));
  };

  const goDeletar = (value: GrupoContaBancoModel) => {
    dispatch(setEntityGrupoContaBanco(value));
    dispatch(setModalDeletarGrupoContaBanco(true));
  };

  const closeModalDeletar = () => {
    dispatch(setModalDeletarGrupoContaBanco(false));
  };

  const items: ItemMenuAcoes[] = [
    {
      label: "Editar",
      key: "1",
      icon: <Icon.EditOutlined />,
      function: (item: any) => goEditar(item),
    },
    {
      label: "Remover",
      key: "2",
      icon: <Icon.DeleteOutlined />,
      function: (item: any) => goDeletar(item),
    },
  ];

  const columns: ColumnsType<GrupoContaBancoModel> = [
    {
      title: "DENOMINAÇÃO",
      dataIndex: "denominacao",
      sorter: (a, b) => a.denominacao.localeCompare(b.denominacao),
      sortDirections: ["ascend", "descend", "ascend"],
    },
    {
      title: "ORDEM",
      dataIndex: "ordem",
      sorter: (a, b) => a.ordem - b.ordem,
      sortDirections: ["ascend", "descend", "ascend"],
    },
    {
      title: "QTD. CONTAS ASSOCIADAS",
      dataIndex: "quantidadeContasAssociadas",
      align: "center",
      sorter: (a, b) => (a.quantidadeContasAssociadas ?? 0) - (b.quantidadeContasAssociadas ?? 0),
      sortDirections: ["ascend", "descend", "ascend"],
    },
    {
      title: "ATIVO",
      dataIndex: "ativo",
      align: "center",
      render: (_, record) => <Switch checked={record.ativo} disabled size="small" />,
    },
    {
      title: "AÇÕES",
      dataIndex: "acoes",
      align: "center",
      width: 75,
      render: (_, record) => <AcoesComponent record={record} items={items} />,
    },
  ];

  return (
    <Flex vertical>
      <Form layout="vertical">
        <Row gutter={12}>
          <Col span={24}>
            <Flex justify="end">
              <ButtonComponent onClick={goCadastro} />
            </Flex>
          </Col>
        </Row>
      </Form>
      <TableComponent data={grupoContaBancoState.list} columns={columns} loading={grupoContaBancoState.loading} />
      <Modal
        title={editar ? "EDITAR GRUPO DE CONTA BANCÁRIA" : "NOVO GRUPO DE CONTA BANCÁRIA"}
        centered
        width={950}
        open={grupoContaBancoState.modalCadastrar}
        closable={false}
        onCancel={closeModalCadastro}
        footer={null}
        destroyOnHidden
      >
        <CadastroGrupoContaBancoModal />
      </Modal>
      <Modal title={"REMOVER GRUPO DE CONTA BANCÁRIA"} centered width={350} open={grupoContaBancoState.modalDeletar} closable={false} onCancel={closeModalDeletar} footer={null} destroyOnHidden>
        <MensagemModal text="Deseja remover o grupo de conta bancária?" action={deletarGrupoContaBanco({ value: grupoContaBancoState.entity.id })} close={setModalDeletarGrupoContaBanco(false)} />
      </Modal>
    </Flex>
  );
};

export default GrupoContaBanco;
